import React, { Fragment, useCallback, useState, useContext } from 'react';
import './Pto.css';
import EmployeeInfo from '../EmployeeInfo/EmployeeInfo';
import Comment from '../Comment/Comment';
import { useFormSetup } from '../../hooks/useFormSetup';
import ValidationErrors from '../Utils/ValidationErrors';
import CbmContext from '../../Context/Cbm/cbmContext';

const Pto = ({ setPayLoad, setFormError, errMsg }) => {
  const cbmContext = useContext(CbmContext);
  const { submittedData, errorCode } = cbmContext;

  const [ptoInfo, setptoInfo] = useState({
    employee: {
      employeeNumber: '',
      employeeFirst: '',
      employeeMiddle: '',
      employeeLast: '',
      employeeSecondLast: '',
    },
    department: '',
    absenceFrom: null,
    absenceTo: null,
    hours: 0,
    comments: '',
    sig: null,
  });

  // Use unified form setup hook
  const { validationErrors, getFieldError } = useFormSetup({
    formName: 'pto',
    formData: ptoInfo,
    setFormData: setptoInfo,
    setPayLoad,
    setFormError,
    submittedData,
    errorCode,
  });

  const onHandleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setptoInfo((prev) => ({
        ...prev,
        [name]: name === 'hours' ? Number(value) : value,
      }));
    },
    [setptoInfo]
  );

  const changeEmpInfo = useCallback(
    (e) => {
      const { name, value } = e.target;
      setptoInfo((prev) => ({
        ...prev,
        employee: { ...prev.employee, [name]: value },
      }));
    },
    [setptoInfo]
  );

  return (
    <Fragment>
      <div className="heading">
        <h1>Pto</h1>
      </div>
      {errMsg && (
        <div className="error-message-container">
          <p className="error-message">{errMsg}</p>
          <ValidationErrors errors={validationErrors} />
        </div>
      )}
      <fieldset>
        <legend>Employee Info</legend>
        <EmployeeInfo
          payload={ptoInfo}
          changeEmpInfo={changeEmpInfo}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      </fieldset>
      <fieldset>
        <legend>Department Info</legend>
        <div
          className={
            errMsg && getFieldError('department')
              ? 'departments error'
              : 'departments'
          }
        >
          <label htmlFor="departments" className="required">
            Departments:{' '}
          </label>
          <select
            id="departments"
            name="department"
            className="department-selector"
            value={ptoInfo.department}
            required
            onChange={(e) => onHandleChange(e)}
          >
            <option value="">Select department</option>
            <option value="Operations">Operations</option>
            <option value="Hr">Human Resources</option>
            <option value="Service">Service</option>
            <option value="Maintenance">Maintenance</option>
          </select>
          {errMsg && getFieldError('department') && (
            <span className="error-text">{getFieldError('department')}</span>
          )}
        </div>
      </fieldset>
      <fieldset>
        <legend>Pto Dates</legend>
        <div className="ptoDates">
          <div
            className={
              errMsg && getFieldError('absenceFrom')
                ? 'ptoStartDate error'
                : 'ptoStartDate'
            }
          >
            <label htmlFor="startDate" className="required">
              Absence from:{' '}
            </label>
            <input
              type="date"
              id="startDate"
              name="absenceFrom"
              value={ptoInfo.absenceFrom || ''}
              required
              onChange={(e) => onHandleChange(e)}
            />
            {errMsg && getFieldError('absenceFrom') && (
              <span className="error-text">{getFieldError('absenceFrom')}</span>
            )}
          </div>
          <div
            className={
              errMsg && getFieldError('absenceTo')
                ? 'ptoEndDate error'
                : 'ptoEndDate'
            }
          >
            <label htmlFor="endDate" className="required">
              Absence to:{' '}
            </label>
            <input
              type="date"
              id="endDate"
              name="absenceTo"
              value={ptoInfo.absenceTo || ''}
              required
              onChange={(e) => onHandleChange(e)}
            />
            {errMsg && getFieldError('absenceTo') && (
              <span className="error-text">{getFieldError('absenceTo')}</span>
            )}
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Pto hours</legend>
        <div
          className={
            errMsg && getFieldError('hours') ? 'ptoHours error' : 'ptoHours'
          }
        >
          <label htmlFor="ptoHours" className="required">
            Enter Pto hours requested:
          </label>
          <input
            type="number"
            id="ptoHours"
            name="hours"
            value={ptoInfo.hours || ''}
            required
            min="0"
            onChange={(e) => onHandleChange(e)}
          />
          {errMsg && getFieldError('hours') && (
            <span className="error-text">{getFieldError('hours')}</span>
          )}
        </div>
      </fieldset>
      <fieldset className="ptoComments">
        <legend>Pto Comments</legend>
        <Comment
          comments={'ptoCommentsId'}
          payload={ptoInfo.comments}
          onHandleChange={(e) => onHandleChange(e)}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      </fieldset>
    </Fragment>
  );
};
// eslint-disable-next-line
Pto.propTypes = {};

export default Pto;
